import React from 'react';

import { Box } from '@mui/material';

import styled from '@emotion/styled';

import Icons from '../../../../themes/icons';
import { AddFundsButton } from '../../../AddFundsButton';
import LoadingButton from '../../../Button/LoadingButton';

type Props = {
  cost: number;
  balance: number;
  loading?: boolean;
  disabled?: boolean;
  accountStatus?: string;
  onUsageRight?: () => void;
  onBuyContent?: () => void;
};

export const BuyContent: React.FC<Props> = ({
  balance,
  loading = false,
  accountStatus,
  onUsageRight,
  onBuyContent,
}) => {
  return (
    <Container>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flex: 1, minWidth: 0 }}>
        <BuyContentHeading>Buy content</BuyContentHeading>
        <UsageDescription as="div">
          After purchase, you can use this content for ads and marketing on Instagram for 90 days.
          The creator retains ownership.{' '}
          <UsageRightLink onClick={onUsageRight} as="span">
            <Box component="span" sx={{ display: 'inline-flex', verticalAlign: 'middle', '& svg path': { fill: '#111' } }}>
              <Icons.UsageRightsIcon style={{ width: 18, height: 18, flexShrink: 0 }} />
            </Box>
            <span style={{ marginLeft: 4 }}>Usage rights</span>
          </UsageRightLink>
        </UsageDescription>
      </Box>
      <Box sx={{ flexShrink: 0 }}>
        {accountStatus === 'inactive' || balance <= 0 ? (
          <AddFundsButton />
        ) : (
          <LoadingButton
            variant='contained'
            sx={{
              paddingY: '16px',
              paddingX: 3,
              backgroundColor: '#000',
              color: '#fff',
              fontWeight: 600,
              borderRadius: '8px',
              '&:hover': { backgroundColor: '#333' },
            }}
            onClick={onBuyContent}
            loading={loading}
            disabled={accountStatus === 'inactive' || balance <= 0}
          >
            Buy Content
          </LoadingButton>
        )}
      </Box>
    </Container>
  );
};

const Container = styled.div`
  border-radius: 8px;
  border: 1px solid #E0E0E0;
  background-color: #F9F9F9;
  padding: 20px 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
`;

const BuyContentHeading = styled.h6`
  padding: 0;
  margin: 0;
  color: #111;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  font-family: Poppins, sans-serif;
`;

const UsageRightLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #111;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.4;
  text-decoration: underline;
  cursor: pointer;
  border: none;
  outline: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  font-family: Poppins, sans-serif;
`;

const UsageDescription = styled.p`
  margin: 0;
  padding: 0;
  color: #111;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.5;
  font-family: Poppins, sans-serif;
`;
